<template>
  <div class="bookpicker" @click="toggleMenu" v-click-outside="closeMenu">
    <div class="selected-text">{{ getSelected }}</div>
    <!-- <font-awesome-icon icon="caret-down" class="dropdown-icon" /> -->
    <span class="mef-font-default mef-font dropdown-icon">p</span>

    <div class="option-items" :class="{ 'mef-open-menu': showMenu }">
      <p
        v-for="(item, index) in sBooks"
        :key="index"
        @click.stop="selectItem(item)"
        class="item-option"
      >
        <span style="padding-right: 7px">{{ item.bookName }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import Menu from "@/mixing/mefMenuFunction.js";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  mixins: [Menu],
  props: ["lazy", "book"],

  computed: {
    ...mapState("mefShas", ["ShasBooks"]),
    ...mapGetters("mefShas", ["getSelectedBookName"]),
    sBooks() {
      let x = JSON.stringify(this.ShasBooks);
      x = JSON.parse(x);

      delete x["176566"];
      delete x["1765660000"];
      for (const property in x) {
        if (!x[property].done) {
          delete x[property];
        }
      }

      // for (let book of x) {
      //   console.log(book);
      // }
      //x = x.filter(i => i.done == true);

      x = Object.values(x);
      x.sort((a, b) => a.o - b.o);
      return x;
    },
    getSelected() {
      if (this.lazy != "1") {
        if (
          this.$store.getters["tabsManager/getCurrentBook"] == 176566 &&
          this.$store.getters["tabsManager/getCurrentPage"] < 30
        )
          return "מעילה";
        return this.getSelectedBookName;
      }

      if (this.book) {
        return this.book.bookName;
      }
      return "מסכת";
    },
    selected() {
      if (this.lazy == "1") return "מסכת";

      let lst = this.ShasBooks.filter((e) => e.book == this.getSelectedBook);
      if (lst.length > 0) {
        return lst[0].masechet;
      }

      return "מסכת";
    },
  },

  methods: {
    selectItem(item) {
      if (!item.done) {
        this.closeMenu();
        return;
      }
      this.$emit("bookselect", item);

      this.closeMenu();
    },
  },
};
</script>

<style scoped>
.bookpicker {
  font-size: 13px;
  line-height: 23px;
  border-left-color: #dcdcdc;
  border-width: 0px;
  display: flex;
  border-left-width: 1px;
  border-style: solid;
  text-align: right;
  min-width: 85px;
  position: relative;
  justify-content: center;
  align-items: center;
}
.selected-text {
  width: 70px;
  padding-right: 9px;
}
.dropdown-icon {
  width: 13px;
  margin-left: 6px;
  height: 14px;
}
.option-items {
  display: none;
  position: absolute;
  z-index: 2;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  top: 100%;
  width: 100px;
  overflow-y: auto;
  max-height: 350px;
}
.mef-open-menu {
  display: block;
}
.item-option:hover {
  background-color: #f5f5f5;
}
.gray {
  color: gray;
}
</style>
